import * as d3 from "d3";
import { BuildTransform } from "./tools";

var zoom = d3.zoom()

const BuildSVG = {
  Base: '',
  Svg: null,
  zoom: d3.zoom(),
  zoomFunc(event) {
    d3.select("#svg > g").attr("transform", event.transform);
  },
  CreateSvg: function (that, pcp) {
    this.Svg = d3.select("#canvas")
      .call(d3.drag().on("end", function () {
        that.unSelected();
      }))
      .append("svg")
      .attr("id", "svg")
      .classed("pcp", pcp)
      .call(zoom.on("zoom", this.zoomFunc))
      .on("dblclick.zoom", null)
      .append("g")
      .on("dblclick.zoom", null)
      .attr("id", "board")

    if (!that.readOnly) {
      this.createDotZero();
    }
    return this.Svg
  },

  Resize: function (transformSTR) {
    let width = document.querySelector("#canvas").clientWidth
    let t = BuildTransform(transformSTR);
    t.scale = t.width ? t.scale * (width / t.width) : t.scale
    this.SetTrasnform(t.x, t.y, t.scale)
  },

  SetTrasnform(x, y, k) {
    let transform = d3.zoomIdentity

    transform.x = isNaN(x) ? 0 : x
    transform.y = isNaN(y) ? 0 : y
    transform.k = isNaN(k) ? 1 : k

    d3.select("#svg").call(zoom.transform, transform)
  },

  AdpterTransform: function (transform) {
    if (this.Base) {
      let { scale, x, y } = { ...this.Base }
      let num = Math.abs(transform.k - (1 - scale))
      transform.x += x
      transform.y += y
      transform.k = isNaN(num) ? 0 : num
    }
    return transform
  },

  createDotZero: function () {
    this.Svg
      .append("g")
      .append("path")
      .attr("d", "M-25,0L-5,0")
      .attr("stroke", '#0008')
      .attr("stroke-width", 2)
      .attr("fill", "#0000")

    this.Svg
      .append("g")
      .append("path")
      .attr("d", "M5,0L25,0")
      .attr("stroke", '#0008')
      .attr("stroke-width", 2)
      .attr("fill", "#0000")

    this.Svg
      .append("g")
      .append("path")
      .attr("d", "M0,-25L0,-5")
      .attr("stroke", '#0008')
      .attr("stroke-width", 2)
      .attr("fill", "#0000")

    this.Svg
      .append("g")
      .append("path")
      .attr("d", "M0,5L0,25")
      .attr("stroke", '#0008')
      .attr("stroke-width", 2)
      .attr("fill", "#0000")

    this.Svg
      .append("g")
      .append("text")
      .text("x:0, y:0")
      .attr("x", 5)
      .attr("y", 7)
      .attr("font-size", 6)
      .style("fill", '#0009')
  }
}

export default BuildSVG

